import { filterClasses } from "@swivl-mono/helpers";
import { TextareaHTMLAttributes, forwardRef } from "react";

export interface TextAreaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  error?: boolean;
}

export const TextAreaField = forwardRef<HTMLTextAreaElement, TextAreaProps>(({ error, className, disabled, readOnly, ...props }, ref) => {
  const isDisabled = disabled || readOnly;

  return (
    <textarea
      ref={ref}
      disabled={disabled || readOnly}
      data-error={error || undefined}
      data-disabled={isDisabled || undefined}
      className={filterClasses(
        "resize-vertical body-sm min-h-[70px] w-full rounded-sm border px-3 py-2 transition-all outline-none",
        "border-grey-400 bg-linear-to-b from-grey-50 via-white via-[22.12%] to-white text-grey-900 placeholder:text-grey-600 hover:border-orange-500 focus:border-orange-500 focus:ring-2 focus:ring-orange-100",
        "data-[error=true]:border-red-500 data-[error=true]:hover:border-red-500 data-[error=true]:focus:border-red-500 data-[error=true]:focus:ring-red-100",
        "data-[disabled=true]:cursor-not-allowed data-[disabled=true]:border-grey-400 data-[disabled=true]:bg-linear-to-b data-[disabled=true]:from-grey-200 data-[disabled=true]:via-grey-200 data-[disabled=true]:to-grey-200 data-[disabled=true]:text-grey-500 data-[disabled=true]:placeholder:text-grey-500 data-[disabled=true]:hover:border-grey-400 data-[disabled=true]:focus:border-grey-400 data-[disabled=true]:focus:ring-0",
        className
      )}
      {...props}
    />
  );
});

TextAreaField.displayName = "TextAreaField";
